import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web/slate/Layout";
import styled, { css, keyframes } from "styled-components";

const shimmer = keyframes`
  100% {
    transform: translateX(100%);
  }
`;

const skeletonColor = Core.surface.subdued;

export const ShimmerPlaceHolder = styled(Row)<{
  $height?: number;
  $width?: number;
  $aspectRatio?: number;
}>`
  height: ${(props) =>
    props.$height
      ? css`
          ${props.$height}px
        `
      : "100%"};

  width: ${(props) =>
    props.$width
      ? css`
          ${props.$width}px
        `
      : "100%"};

  ${(props) =>
    props.$aspectRatio
      ? css`
          aspect-ratio: ${props.$aspectRatio};
        `
      : ""}

  background: ${Core.surface.subdued};
  position: relative;
  overflow: hidden;
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      ${skeletonColor}00 0,
      ${skeletonColor}33 20%,
      ${skeletonColor}7F 60%,
      ${skeletonColor}00
    );
    animation: ${shimmer} 1.5s infinite;
    content: '';
`;
